import type { FC } from 'react';
import Spin from 'antd/es/spin';
import { cn } from 'app/lib/utils';

export interface SpinnerProps {
  className?: string;
  /** Visual size */
  size?: 'sm' | 'md' | 'lg';
}

const spinSize: Record<
  NonNullable<SpinnerProps['size']>,
  'small' | 'default' | 'large'
> = {
  sm: 'small',
  md: 'default',
  lg: 'large',
};

/**
 * Loading indicator façade over antd `Spin` (no children).
 */
export const Spinner: FC<SpinnerProps> = ({ className, size = 'md' }) => (
  <Spin spinning size={spinSize[size]} className={cn(className)} />
);

export default Spinner;
